import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { IdentifiedKPIValue } from "@/types/kpiTypes.ts"

export const getAllKPIValues = async (): Promise<IdentifiedKPIValue[]> => {
  const { data, error, response } = await apiClient.GET("/api/KPIs/values")
  return assertOk(response, error, data)
}
